import {
  Component,
  OnInit
} from '@angular/core';
import {
  MobileDetectService,
  RouterService,
  StoryModel,
  UserModel,
  UserService
} from '@lib/gc-common';

@Component({
  selector: 'mip-profile-stories',
  templateUrl: './profile-stories.component.html',
  styleUrls: ['./profile-stories.component.scss'],
})
export class ProfileStoriesComponent implements OnInit {
  
  profile: UserModel = null;
  stories: StoryModel[] = [];
  
  isMobile = false;
  
  constructor(
    private routerService: RouterService,
    private userService: UserService,
    private mobileDetect: MobileDetectService
  ) {
    this.isMobile = this.mobileDetect.isMobile();
  }
  
  async ngOnInit() {
    
    const { params } = await this.routerService.getRouteObject();
    console.log('profile-stories.component->ngOnInit() params', params);
    
    this.profile = await this.userService.getUser(params.userId);
    console.log('profile-stories.component->ngOnInit() this.profile', this.profile);
    
    this.stories = await this.profile.getStories();
    console.log('profile-stories.component->ngOnInit(): this.stories', this.stories);
    
  }
}
